<template>
  <nuxt-icon
    class="inline-block w-(--iconSize) h-(--iconSize) !shrink-0"
    :name="icon"
    :size="size.toString()"
    :style="{
      '--iconSize': `${size}px`,
    }"
  />
</template>

<script lang="ts" setup>
import { Icon as NuxtIcon } from "#components";

withDefaults(
  defineProps<{
    icon: string;
    size?: number;
    duotone?: boolean;
  }>(),
  {
    size: 24,
  },
);
</script>
